import {
  getAbandonedCart as publicGetAbandonedCart,
  queryAbandonedCarts as publicQueryAbandonedCarts,
} from './stores-v1-abandoned-cart-abandoned-carts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onAbandonedCartCartAbandonedEvent as publicOnAbandonedCartCartAbandonedEvent } from './stores-v1-abandoned-cart-abandoned-carts.public.js';
import { onAbandonedCartCartRecoveredEvent as publicOnAbandonedCartCartRecoveredEvent } from './stores-v1-abandoned-cart-abandoned-carts.public.js';

/** @internal */
export const getAbandonedCart: MaybeContext<
  BuildRESTFunction<typeof publicGetAbandonedCart> &
    typeof publicGetAbandonedCart
> = /*#__PURE__*/ createRESTModule(publicGetAbandonedCart);
/** @internal */
export const queryAbandonedCarts: MaybeContext<
  BuildRESTFunction<typeof publicQueryAbandonedCarts> &
    typeof publicQueryAbandonedCarts
> = /*#__PURE__*/ createRESTModule(publicQueryAbandonedCarts);
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This webhook has been replaced with the
 * [Abandoned Checkout Created Webhook](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/abandoned-checkout/abandoned-checkout-created)
 * and will be removed on March 31, 2024.
 *
 * </blockquote>
 * @deprecated
 */
export const onAbandonedCartCartAbandonedEvent: BuildEventDefinition<
  typeof publicOnAbandonedCartCartAbandonedEvent
> &
  typeof publicOnAbandonedCartCartAbandonedEvent = createEventModule(
  publicOnAbandonedCartCartAbandonedEvent
);
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This webhook has been replaced with the
 * [Abandoned Checkout Recovered Webhook](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/abandoned-checkout/abandoned-checkout-recovered)
 * and will be removed on March 31, 2024.
 *
 * </blockquote>
 * @deprecated
 */
export const onAbandonedCartCartRecoveredEvent: BuildEventDefinition<
  typeof publicOnAbandonedCartCartRecoveredEvent
> &
  typeof publicOnAbandonedCartCartRecoveredEvent = createEventModule(
  publicOnAbandonedCartCartRecoveredEvent
);

export {
  Status,
  Identity,
  ActivityType,
  WebhookIdentityType,
} from './stores-v1-abandoned-cart-abandoned-carts.universal.js';
export {
  AbandonedCart,
  BuyerInfo,
  Activity,
  CustomData,
  CartAbandonedEvent,
  Totals,
  CartRecoveredEvent,
  CartDeletedEvent,
  GetAbandonedCartRequest,
  GetAbandonedCartResponse,
  QueryAbandonedCartsRequest,
  Query,
  Paging,
  QueryAbandonedCartsResponse,
  DeleteCartRequest,
  DeleteCartResponse,
  RedirectToCheckoutRequest,
  RawHttpResponse,
  HeadersEntry,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  AbandonedCartCartAbandonedEnvelope,
  AbandonedCartCartRecoveredEnvelope,
  QueryAbandonedCartsOptions,
} from './stores-v1-abandoned-cart-abandoned-carts.universal.js';
export {
  StatusWithLiterals,
  IdentityWithLiterals,
  ActivityTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './stores-v1-abandoned-cart-abandoned-carts.universal.js';
